export const RETRY_PUBLISH_TIMEOUT = 300; // 5 минут

export const AUTOFILL_FIELDS_MAP: Record<string, string> = {
  area: 'land_sq',
  totalArea: 'house_sq',
  isDacha: 'house_type',
  status: 'use_type',
  floorsCount: 'house_stages',
  areaUnitType: 'land_sq_unit',
};
